<!-- 企微通码用户引流 -->
<template>
  <div class="wrap">
    <div class="main" :style="{ backgroundImage: `url(${bg})` }" @click="clickPage">
      <div v-if="hasFetch && !qrCode" class="tip">
        链接已失效，请联系客服
      </div>
      <img v-if="qrCode" :src="qrCode" class="qrc" />
    </div>
  </div>
</template>

<script>
import { getDouyinQWCommonInfo } from '@/apis/gameJump'
// 创建 webview 环境用
import EventTrack from '@/mixins/eventTrack'
import track from './components/track'
import { checkIsWxBrowser } from "@/libs/utils";
import { IS_YW } from '@/config'
export default {
  data () {
    return {
      user_id: '',
      bg: '',
      qrCode: '',
      general_config_id: '',
      qy_weixin_user: '',
      hasFetch: false,
    }
  },
  mixins: [EventTrack, track],
  created () {
    this.judgeChannel()
  },
  computed: {
    gu () {
      return this.$route.query.gu
    },
  },
  methods: {
    // 判断投放渠道
    judgeChannel () {
      this.user_id = this.$route.query.user_id
      this.getInfo()
      if (checkIsWxBrowser()) {
        document.title = ' '
      }
    },
    getInfo () {
      getDouyinQWCommonInfo({
        user_id: this.user_id,
        gu: this.gu,
      }).then(res => { 
        console.log(res)
        const { status, qy_qr_code, qy_weixin_user, id, background } = res.content
        if (status === 1) {
          this.bg = background
          this.qrCode = qy_qr_code
          this.general_config_id = id
          this.buryReport("QY_WEIXIN_GENERAL_SHOW", {
            general_config_id: id,
            user_id: this.user_id,
            "is_douyin": 1
          });
          this.redirect()
        }
      }).finally(() => {
        this.hasFetch = true
      })
    },
    redirect () {
      if (checkIsWxBrowser()) return
      const appid = 'wx7ebd52bd136e97d9'
      let data = encodeURIComponent(`user_id=${this.user_id}&gu=${this.gu}`)
      const ENV_VERSION = 'release' // 正式版为release，体验版为trial，开发版为develop
      // 根据域名判断路径：悦玩使用 ywDouyin，玩心使用 douyin
      const path = IS_YW ? 'pages/ywDouyin/index' : 'pages/douyin/index'
      window.location.href = `weixin://dl/business/?appid=${appid}&path=${path}&query=${data}&env_version=${ENV_VERSION}`
    },
    clickPage () {
      // 链接失效时无交互
      if (this.hasFetch && !this.qrCode) return
      this.buryReport("QY_WEIXIN_GENERAL_CLICK", {
        general_config_id: this.general_config_id,
        user_id: this.user_id,
        "is_douyin": 1
      })
      this.redirect()
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  position: relative;
  width: 100vw;
  height: 100vh;
  // 有一定程度的拉伸
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 50% 100%;
  .qrc {
    position: absolute;
    right: 44px;
    bottom: 58px;
    width: 140px;
  }
  .tip {
    margin-top: 120px;
    text-align: center;
    font-size: 18px;
  }
}
</style>
